var angular = require('angular');

var app = angular.module('app');

function ModalMapController(store, closeDeferred, $window) {
    this.store = store;

    this.close = function ($event) {
        $event.preventDefault();

        closeDeferred.resolve();
    };

    this.print = function () {
        $window.print();
    };
}
app.controller('ModalMapController', ModalMapController);

